import get from 'lodash/get';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import FormControl from '../../FormControl/FormControl';
import { FieldArgs, RadioGroupField } from '../types';
import { useFormError } from '../utils';
import RadioGroup from '../../RadioGroup/RadioGroup';
import Radio from '../../Radio/Radio';
import InputLabel from '../../InputLabel/InputLabel';

export type Props = FieldArgs<RadioGroupField>;

const RadioGroupAdapter = (props: Props) => {
  const { label, name, rules, disabled, options, defaultValue } = props;
  const { control, formState } = useFormContext();
  const error = useFormError(get(formState.errors, name));

  return (
    <FormControl error={!!error} disabled={disabled}>
      {label && <InputLabel>{label}</InputLabel>}
      <Controller
        name={name}
        rules={rules}
        control={control}
        disabled={disabled}
        defaultValue={defaultValue}
        render={({ field: { onChange, value } }) => {
          return (
            <RadioGroup onChange={onChange} value={value ?? ''} name={name}>
              {options.map((item) => (
                <Radio
                  id={`${name}_${item.value}`}
                  value={item.value}
                  label={item.label}
                  key={item.value}
                />
              ))}
            </RadioGroup>
          );
        }}
      />
    </FormControl>
  );
};

export default RadioGroupAdapter;
